import React from "react";
import ReactDOM from "react-dom";

import Newsletter from "../components/newsletter/newsletter";

function newsletter() {
  const container = document.getElementById("js-newsletter-form");

  if (container) {
    ReactDOM.render(<Newsletter />, container);
  }
}

export default newsletter;



// WEBPACK FOOTER //
// ./controllers/Newsletter.jsx